import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { ClientPaymentTermsService } from '@app/core/client/services/client-payment-terms.service';
import {
  ClientPurchaseOrderType,
  ClientPurchaseOrderTypeService,
} from '@app/core/client/services/client-purchase-order-type.service';
import { SettingsService } from '@app/core/settings/services/settings.service';

@Component({
  selector: 'filter-client-payment-term',
  templateUrl: './filter-client-payment-term.component.html',
  styleUrls: ['./filter-client-payment-term.component.scss'],
})
export class FilterClientPaymentTermComponent implements OnInit {
  constructor(
    private cd :ChangeDetectorRef,
    private settingsSvc :SettingsService,
  ) {}

  @Input() value :string;
  @Input() label :string = 'Client payment term';
  @Output() changePaymentTerm :EventEmitter<string> = new EventEmitter<string>();

  public isLoading :boolean = true;
  public paymentTerms :any = [];

  ngOnInit() :void {
    this.settingsSvc.paymentTerms$.subscribe((paymentTerms :any) => {
      if (paymentTerms && paymentTerms.length > 0) {
        this.paymentTerms = paymentTerms;
        this.isLoading = false;
        this.cd.detectChanges();
      }
    });
  }

  onChange() {
    this.changePaymentTerm.emit(this.value);
  }
}
